module.exports = __webpack_public_path__ + "img/9788958283003.2ff5d216.jpg";